import { createFileRoute } from '@tanstack/react-router'
import { CommunityPostPage } from '../components/pages'
import { CatalogProvider } from '../content/catalog-context'
import { loadPageData } from '../content/page-data-fn'

export const Route = createFileRoute('/fr/communaute/publications/$postSlug')({
  loader: ({ params }) =>
    loadPageData({ data: { kind: 'post', locale: 'fr', params } }),
  head: ({ loaderData }) => loaderData?.head ?? {},
  component: RouteComponent,
})

function RouteComponent() {
  const { postSlug } = Route.useParams()
  return (
    <CatalogProvider snapshot={Route.useLoaderData().snapshot}>
      <CommunityPostPage postSlug={postSlug} />
    </CatalogProvider>
  )
}
